//#region
import axios from 'axios';
import { url, endPoint } from '../urls';
//#endregion

export function getUserType(params) {
    let _url = url.backendHost + endPoint.userType.getUserType;
    return axios.get(_url, { params });
}

export function addUserType(params) {
    let _url = url.backendHost + endPoint.userType.addUserType;
    delete params._id
    return axios.post(_url, params);
}

export function updateUserType(params) {
    let _url = url.backendHost + endPoint.userType.updateUserType;
    return axios.put(_url, params);
}

export function deleteUserType(params) {
    let _url = url.backendHost + endPoint.userType.deleteUserType;
    return axios.put(_url, params);
}

export function updateUserTypeForDashboard(params) {
    let _url = url.backendHost + endPoint.userType.updateUserTypeForDashboard;
    return axios.patch(_url, params);
}

export function getUserTypeByDashboardId(params) {
    let _url = url.backendHost + endPoint.userType.getUserTypeByDashboardId;
    return axios.get(_url, { params });
}